// extracted by css-extract-rspack-plugin
export default {"empty":"src-modules-desktop-modules-widgets-components-AiArtifacts-components-AiArtifactTileWidget-AiArtifactTileWidget-module__empty-quLO69","frameSlot":"src-modules-desktop-modules-widgets-components-AiArtifacts-components-AiArtifactTileWidget-AiArtifactTileWidget-module__frameSlot-WbftEW"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"empty\":\"src-modules-desktop-modules-widgets-components-AiArtifacts-components-AiArtifactTileWidget-AiArtifactTileWidget-module__empty-quLO69\",\"frameSlot\":\"src-modules-desktop-modules-widgets-components-AiArtifacts-components-AiArtifactTileWidget-AiArtifactTileWidget-module__frameSlot-WbftEW\"}";
        // 1793873549255
        var cssReload = require("../../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  